export default "__VITE_ASSET__xnFzEQrc__"